import styled from '@emotion/styled';
import React from 'react';

export const LayoutBackground = ({
    hideBottomBlob,
}: {
    hideBottomBlob?: boolean;
}) => (
    <Container>
        <TopImage
            src="https://cdn.evbstatic.com/s3-build/perm_001/6e32ef/django/images/create/auto-creation/auto-create_layout-top.png"
            alt=""
        />
        <RightImage
            src="https://cdn.evbstatic.com/s3-build/perm_001/eca626/django/images/create/auto-creation/auto-create_layout-right.png"
            alt=""
        />
        {(hideBottomBlob == undefined || !hideBottomBlob) && (
            <BottomImage
                src="https://cdn.evbstatic.com/s3-build/perm_001/1776cb/django/images/create/auto-creation/auto-create_layout-bottom.png"
                alt=""
            />
        )}
    </Container>
);

const Container = styled.div`
    z-index: -1;
    position: absolute;
    height: 100%;
    width: 100%;
    overflow: hidden;
`;

const TopImage = styled.img`
    position: fixed;
    width: 460px;
    top: 0;
    left: 200px;
`;

const RightImage = styled.img`
    position: fixed;
    width: 70px;
    right: 0;
    top: 30%;
`;

const BottomImage = styled.img`
    position: fixed;
    width: 300px;
    bottom: 0;
    left: 100px;
`;
